var LORRY_STATUS;
(function (LORRY_STATUS) {
    LORRY_STATUS[LORRY_STATUS["ALL"] = -1] = "ALL";
    LORRY_STATUS[LORRY_STATUS["ACTIVE"] = 3] = "ACTIVE";
    LORRY_STATUS[LORRY_STATUS["IN_TRANSIT"] = 4] = "IN_TRANSIT";
    LORRY_STATUS[LORRY_STATUS["IN_ACTIVE"] = 0] = "IN_ACTIVE";
    LORRY_STATUS[LORRY_STATUS["STAND_BY"] = 5] = "STAND_BY";
    LORRY_STATUS[LORRY_STATUS["VERIFICATION_FAILED"] = 999] = "VERIFICATION_FAILED";
})(LORRY_STATUS || (LORRY_STATUS = {}));
var LORRY_STATUS_TEXT;
(function (LORRY_STATUS_TEXT) {
    LORRY_STATUS_TEXT["ALL"] = "All";
    LORRY_STATUS_TEXT["IN_ACTIVE"] = "In Active";
    LORRY_STATUS_TEXT["ACTIVE"] = "Active";
    LORRY_STATUS_TEXT["IN_TRANSIT"] = "In Transit";
    LORRY_STATUS_TEXT["VERIFICATION_FAILED"] = "Verification Failed";
    LORRY_STATUS_TEXT["STAND_BY"] = "Stand By";
})(LORRY_STATUS_TEXT || (LORRY_STATUS_TEXT = {}));
const ACTION_BY_LORRY_STATUS = {
    EDIT_LORRY: [LORRY_STATUS.ACTIVE],
    ADD_DRIVER_DETAILS: [LORRY_STATUS.ACTIVE, LORRY_STATUS.IN_TRANSIT]
};

export { ACTION_BY_LORRY_STATUS, LORRY_STATUS, LORRY_STATUS_TEXT };
//# sourceMappingURL=lorryStatus.js.map
